var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"wrap-label"},[_c('span',[_vm._v(_vm._s(_vm.name || _vm.label))])]),_c('div',{staticClass:"wrap-body"},[_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.line),expression:"line"}],staticClass:"wrap-line"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }